import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FiltersetsRoutes } from 'app/filtersets/routes/filtersets-routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(FiltersetsRoutes)
  ],
  exports: [RouterModule]
})
export class FiltersetsRoutingModule { }
